// extracted by mini-css-extract-plugin
export default {"faq":"faq_faq__qVRrP","title":"faq_title__XPK-j","questions":"faq_questions__eRHdN"};